import React from "react";

// Renders an Adinkra symbol as a CSS mask so it can be tinted to any brand
// colour via `currentColor` (set through Tailwind text-* classes).
// Bold SVGs live in /public/adinkra/{symbol}.svg (single-path silhouettes).
const BASE = `${process.env.PUBLIC_URL || ""}/adinkra`;

export const AdinkraMark = ({ symbol, className = "", style = {} }) => {
  const url = `${BASE}/${symbol}.svg`;
  return (
    <span
      role="presentation"
      aria-hidden="true"
      data-adinkra={symbol}
      className={className}
      style={{
        display: "inline-block",
        backgroundColor: "currentColor",
        WebkitMaskImage: `url("${url}")`,
        maskImage: `url("${url}")`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        ...style,
      }}
    />
  );
};

export default AdinkraMark;
